<main class="fld-col jc-ctr">
  <section
    id="lookup-by-section"
    class="fld-col fld-dsk-col flg-3 pwt-4 ai-ctr jc-ctr card"
  >
    <div class="fw-u1">
      <p class="mwtr-0">
        Please enter your vehicle information and the last 4-digit of your
        credit card used to pay for your membership.
      </p>
      <p>
        We will use this information to connect your account with myQQ. <br />

        This will not affect your billing.
      </p>
    </div>

    <form [formGroup]="form" class="card-form fld-col fls-1-0 flg-5">
      <mat-form-field id="type">
        <mat-label>Search By</mat-label>
        <select matNativeControl formControlName="type">
          <option
            *ngFor="let option of lookupBy | keyvalue"
            [value]="option.key"
            >{{ option.value }}</option
          >
        </select>
      </mat-form-field>

      <div id="lp-section" class="fld-row flg-5" *ngIf="!isVIN">
        <mat-form-field id="state">
          <mat-label>State</mat-label>
          <select matNativeControl formControlName="state">
            <option value=""></option>
            <option *ngFor="let state of states" [value]="state.abbreviation">
              {{ state.abbreviation }}
            </option>
          </select>
        </mat-form-field>
        <mat-form-field id="license">
          <mat-label>License Plate</mat-label>
          <input
            matInput
            id="license-input"
            placeholder="ABC123"
            formControlName="license"
            maxlength="10"
            [mask]="licenseMask"
          />
        </mat-form-field>
      </div>

      <div *ngIf="isVIN" id="vin-section">
        <mat-form-field id="vin">
          <mat-label>VIN</mat-label>
          <input
            matInput
            id="vin-input"
            formControlName="vin"
            maxlength="17"
            [patterns]="vinMask.customPattern"
            [mask]="vinMask.mask"
          />
        </mat-form-field>
      </div>
      <span class="as-ctr"> AND </span>
      <section id="last4-section">
        <mat-form-field id="last4">
          <mat-label>Last 4 Digits Of Your Credit Card</mat-label>
          <input
            class="vw-p100"
            matInput
            placeholder="1234"
            formControlName="last4"
            maxlength="4"
            (keydown.enter)="submit()"
            (keyup.enter)="$event.preventDefault()"
          />
        </mat-form-field>
      </section>
    </form>

    <footer class="fld-row flg-4 jc-ctr">
      <button
        myqq-button
        class="raised normal cf-base"
        (click)="skipLookup()"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="skipLookup()"
        aria-label="cancel"
      >
        Cancel
      </button>
      <button
        myqq-button
        color="primary"
        class="raised normal"
        [disabled]="form.invalid"
        (click)="submit()"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="submit()"
        aria-label="next"
      >
        Next
      </button>
    </footer>
  </section>
</main>
